module.exports = __webpack_public_path__ + "static/media/in_yan.f6145cf2.jpeg";